/**
 * @generated SignedSource<<033fcf1dacd0524f3a80f42999f5114d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AskFellowHooksCreateConversationMutation$variables = {
  contextId?: string | null;
  filters?: string | null;
};
export type AskFellowHooksCreateConversationMutation$data = {
  readonly createAskCopilotConversationForUser: {
    readonly conversation: {
      readonly context: {
        readonly filters: string | null;
        readonly name: string;
      } | null;
      readonly id: string;
      readonly suggestedQuestions: ReadonlyArray<{
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"AskFellowSuggestedQuestions_SuggestedQuestionButton_suggestedQuestion">;
      }>;
    };
  } | null;
};
export type AskFellowHooksCreateConversationMutation = {
  response: AskFellowHooksCreateConversationMutation$data;
  variables: AskFellowHooksCreateConversationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contextId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filters"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "contextId",
    "variableName": "contextId"
  },
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "filters"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "AskCopilotConversationContext",
  "kind": "LinkedField",
  "name": "context",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "filters",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AskFellowHooksCreateConversationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateAskCopilotConversation",
        "kind": "LinkedField",
        "name": "createAskCopilotConversationForUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AskCopilotConversation",
            "kind": "LinkedField",
            "name": "conversation",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SuggestedQuestion",
                "kind": "LinkedField",
                "name": "suggestedQuestions",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AskFellowSuggestedQuestions_SuggestedQuestionButton_suggestedQuestion"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AskFellowHooksCreateConversationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateAskCopilotConversation",
        "kind": "LinkedField",
        "name": "createAskCopilotConversationForUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AskCopilotConversation",
            "kind": "LinkedField",
            "name": "conversation",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SuggestedQuestion",
                "kind": "LinkedField",
                "name": "suggestedQuestions",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "content",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "contentForDisplay",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8f1d1ea5715027e89d7c4167dd95e147",
    "id": null,
    "metadata": {},
    "name": "AskFellowHooksCreateConversationMutation",
    "operationKind": "mutation",
    "text": "mutation AskFellowHooksCreateConversationMutation(\n  $contextId: ID\n  $filters: JSONString\n) {\n  createAskCopilotConversationForUser(contextId: $contextId, filters: $filters) {\n    conversation {\n      id\n      context {\n        name\n        filters\n      }\n      suggestedQuestions {\n        id\n        ...AskFellowSuggestedQuestions_SuggestedQuestionButton_suggestedQuestion\n      }\n    }\n  }\n}\n\nfragment AskFellowSuggestedQuestions_SuggestedQuestionButton_suggestedQuestion on SuggestedQuestion {\n  id\n  content\n  contentForDisplay\n}\n"
  }
};
})();

(node as any).hash = "05f29deeeace76bed244c584ce07db57";

export default node;
